<!-- 讨论区主干 -->
<template>
  <div class="zlr-discuss">
    <h1>{{title}}</h1>
    <div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
// less
import './discuss.less'
export default {
  name: 'zlr-discuss',
  props: ['title'],
  components: {},
  data () {
    return {
    }
  },
  computed: {},
  mounted () { },
  methods: {}
}
</script>
<style lang='less' scoped>
</style>
